import { useFetchQuery, useMutation } from "hooks/useQueries";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { useParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "store/store";
import {
  GET_LEAD_BY_ID,
  GET_LEAD_SOURCE,
  GET_LEAD_STATUS,
} from "utils/apiRoutes";
import axiosInstance from "utils/axiosInstance";
import { SelectOption } from "utils/common";
import { refetchQuery } from "utils/helpers";
import { QueryKeys } from "utils/queryKey";

export const useUpdateLead = () => {
  const { id } = useParams();

  const countryList = useAppSelector((state) => state?.app?.countryList);
  const stateList = useAppSelector((state) => state?.app?.stateList);
  const cityList = useAppSelector((state) => state?.app?.cityList);

  const dispatch = useAppDispatch();

  const [statusList, setStatusList] = useState<SelectOption[]>([]);

  const [sourceList, setSourceList] = useState<SelectOption[]>([]);

  const [addStatusModal, setAddStatusModal] = useState(false);

  const [type, setType] = useState("STATUS");

  const [updateValue, setUpdateValue] = useState({});

  const { data: leadData, isFetching } = useFetchQuery({
    key: [QueryKeys.GET_LEAD],
    route: GET_LEAD_BY_ID(id),
  });

  const [isOpenLogsModal, setIsOpenLogsModal] = useState(false);

  const form = useForm({
    defaultValues: {
      name: "",
      companyName: "",
      leadValue: 0,
      position: "",
      address: "",
      city: "",
      state: "",
      pincode: "",
      country: "",
      description: "",
      phoneNumber: "",
      lastContacted: "",
      email: "",
      tags: "",
      leadAssignedTo: "",
      sourceOfLead: "",
      leadStatus: "",
      panNumber: "",
    },
    values: leadData?.data?.data,
  });

  const { refetch: statusRefetch, isFetching: statusFetching } = useFetchQuery({
    key: [QueryKeys.GET_STATUS],
    route: GET_LEAD_STATUS,
    success: (data: any) => {
      refetchQuery("GET_ALL_LEAD_LOGS");
      setStatusList(
        data?.data?.data?.map((status: any) => ({
          ...status,
          name: status.leadstatus,
          value: status.id,
        })),
      );
    },
  });

  const { refetch: sourceRefetch } = useFetchQuery({
    key: [QueryKeys.GET_SOURCE],
    route: GET_LEAD_SOURCE,
    success: (data: any) => {
      refetchQuery("GET_ALL_LEAD_LOGS");
      setSourceList(
        data?.data?.data?.map((s: any) => ({
          name: s.leadsource,
          value: s.id,
        })),
      );
    },
  });

  const { mutate: updateLead } = useMutation({
    mutationFn: (data: any) => axiosInstance.patch(`/lead/${id}/`, data),
    onSuccess: () => {
      refetchQuery("GET_ALL_LEAD_LOGS");
      refetchQuery(QueryKeys.GET_LEAD);
    },
  });

  const { mutate: handleDeleteStatus } = useMutation({
    mutationFn: (data: any) => axiosInstance.delete(`/lead-status/${data}/`),
    onSuccess: () => {
      statusRefetch();
      refetchQuery("GET_ALL_LEAD_LOGS");
      refetchQuery(QueryKeys.GET_LEAD);
    },
  });

  const { mutate: handleDeleteSource } = useMutation({
    mutationFn: (data: any) => axiosInstance.delete(`/lead-source/${data}/`),
    onSuccess: () => {
      refetchQuery(QueryKeys.GET_LEAD);

      refetchQuery("GET_ALL_LEAD_LOGS");
      sourceRefetch();
    },
  });

  return {
    statusList,
    sourceList,
    statusRefetch,
    sourceRefetch,
    updateLead,
    handleDeleteStatus,
    handleDeleteSource,
    addStatusModal,
    setAddStatusModal,
    type,
    setType,
    updateValue,
    setUpdateValue,
    isOpenLogsModal,
    setIsOpenLogsModal,
    form,
    isFetching,
    statusFetching,
    leadData,
    countryList,
    dispatch,
    cityList,
    stateList,
  };
};
